import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/billing/invoices')({
  staticData: { crumb: { parents: [{ label: 'Billing' }], label: 'Invoices' } },
})
